import { computed, Injectable, signal } from "@angular/core";
import { CustomerSettingsDataService } from "src/app/services/customer-settings-data.service";

import { Company } from "../models/Company";
import { AuthService } from "./auth.service";
import { CompanyService } from "./company.service";

@Injectable({
  providedIn: "root",
})
export class TechCoverVisibilityService {
  private readonly techCoverEnabledSignal = signal<boolean>(false);
  public readonly isTechCoverComputed = computed(() => this.techCoverEnabledSignal());

  constructor(
    private authService: AuthService,
    private customerSettingsDataService: CustomerSettingsDataService,
    private companyService: CompanyService,
  ) {
    this.initializeTechCoverStatus();
  }

  private async initializeTechCoverStatus(): Promise<void> {
    // Early return if user doesn't have permission for TechCover
    if (!this.authService.user?.allowTechCover) {
      return;
    }

    // Check on company level
    const initialCompany = this.companyService.selectedCompany;
    if (initialCompany) {
      const initialSettings = await this.customerSettingsDataService.getCustomerSettingsAsync(
        initialCompany.name,
      );
      this.techCoverEnabledSignal.set(initialSettings?.isTechCoverEnabled ?? false);
    }

    // Subscribe to future company changes
    this.companyService.companyChange.subscribe(async (company: Company) => {
      const customerSettings = await this.customerSettingsDataService.getCustomerSettingsAsync(
        company.name,
      );
      this.techCoverEnabledSignal.set(customerSettings?.isTechCoverEnabled ?? false);
    });
  }

  async getTechCoverStatusAsync(): Promise<boolean> {
    await this.customerSettingsDataService.getCustomerSettingsAsync(
      this.companyService.selectedCompany?.name,
    );
    return this.isTechCoverComputed();
  }
}
